'use strict';

const createIbanInput = $('input[name="iban"]');
const showIbanInput = $('input[data-input-name="iban"]');
const accountNumberInput = $('input[name="account_number"]');


$(document).ready(function () {
    if (createIbanInput.length !== 0) {
        if (createIbanInput.val().length !== 0) {
            showFormattedIban(createIbanInput);
        } else {
            createFormattedIban(createIbanInput);
        }
    } else if (showIbanInput.length !== 0) {
        showFormattedIban(showIbanInput);
    }

    if (accountNumberInput.length !== 0) {
        accountNumberInput.on('keyup', function (e) {
            accountNumberInput.val(onlyNumericCharacter(e.target.value));
        });
    }

    function onlyNumericCharacter(value) {
        return value.replace(/[^0-9]+/g, '');
    }

    function createFormattedIban(element) {
        new Cleave(element, {
            prefix: 'TR',
            blocks: [4, 4, 4, 4, 4, 4, 2],
        });
    }

    function showFormattedIban(element) {
        new Cleave(element, {
            blocks: [4, 4, 4, 4, 4, 4, 2],
        });
    }
});
